import { render, staticRenderFns } from "./VocabularyManager.vue?vue&type=template&id=4c11ed22&"
import script from "./VocabularyManager.vue?vue&type=script&lang=ts&"
export * from "./VocabularyManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports